// ============================================================================
// viewSettings.ts — ЕДИНЫЙ источник «Видов» (как в 1С):
//   JSON: {"list":{"desktop":{"view","cardTemplate"},"mobile":{}},"object":{...}}
// SSoT — сервер (view_settings объектов метаданных); эти функции — только
// парсинг/выбор по устройству. Импортируются И редактором (ViewSettingsEditor),
// И точкой применения (AutoListForm) — никаких зависимостей между компонентами.
// ============================================================================

export interface ViewSettings {
  list?: {
    desktop?: { view?: string; cardTemplate?: string };
    mobile?: { view?: string; cardTemplate?: string };
  };
  object?: {
    desktop?: { view?: string; cardTemplate?: string };
    mobile?: { view?: string; cardTemplate?: string };
  };
}

export function parseViewSettings(json?: string): ViewSettings {
  if (!json) return {};
  try {
    return JSON.parse(json) as ViewSettings;
  } catch {
    return {};
  }
}

export function stringifyViewSettings(v: ViewSettings): string {
  return JSON.stringify(v);
}

// Какой вид применять для текущего устройства (desktop/mobile)
export function viewForDevice(v: ViewSettings | undefined, kind: 'list' | 'object', isMobile: boolean): { view: string; cardTemplate?: string } | undefined {
  const section = kind === 'list' ? v?.list : v?.object;
  const cfg = isMobile ? section?.mobile : section?.desktop;
  if (!cfg?.view) return undefined;
  return { view: cfg.view, cardTemplate: cfg.cardTemplate };
}
